<template>
  <div>
    <b-card no-body>
      <!-- Head -->
      <table-header
        search
        search-placeholder="Cari berdasarkan nama"
        search-action="roles/getRolesList"
      >
        <template #action>
          <b-button
            v-if="canAccess('manage', 'Role')"
            variant="primary"
            :to="{ name: 'roles-create'}"
          >
            Buat Role
          </b-button>
        </template>
      </table-header>
      <!-- Body -->
      <b-skeleton-table
        v-if="isLoading"
        :rows="5"
        :columns="4"
      />
      <b-table
        v-else
        ref="refUserListTable"
        :items="roles.data"
        responsive
        :fields="tableFields"
        primary-key="id"
        show-empty
        empty-text="Tidak ada data yang ditemukan"
        class="position-relative mh-160"
      >

        <!-- Column: Name -->
        <template #cell(name)="data">
          {{ data.item.name }}
        </template>

        <!-- Column: Guard Name -->
        <template #cell(guard_name)="data">
          {{ data.item.guard_name }}
        </template>

        <!-- Column: Guard Name -->
        <template #cell(permissions)="data">
          <b-badge
            v-for="(item, index) in data.item.permissions"
            :key="`list-permission-${index}`"
            :variant="item.action === 'manage' ? 'light-primary' : 'light-info'"
            class="mb-1 mr-1"
          >
            {{ item.permission }}.{{ item.action }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canAccess('manage', 'Role')"
          #cell(actions)="data"
        >
          <div class="text-nowrap">
            <table-action
              :actions="tableAction"
              :data="data"
            />
          </div>
        </template>

      </b-table>
      <!-- Footer -->
      <div class="mx-2 mb-2">
        <pagination
          :data="roles.meta"
          action="roles/getRolesList"
        />
      </div>
    </b-card>

    <b-modal
      v-if="canAccess('manage', 'Role')"
      id="modal-delete"
      title="Apakah anda yakin"
      @hidden="deletedData = ''"
    >
      Ingin Menghapus Role ini?
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-secondary"
          :disabled="isDeleting"
          @click="cancel()"
        >
          Batalkan
        </b-button>
        <b-button
          variant="danger"
          :disabled="isDeleting"
          @click.prevent="handleDelete"
        >
          <b-spinner
            v-if="isDeleting"
            small
            label="Spinning"
          />
          {{ isDeleting ? 'Menghapus' : 'Ya, Hapus' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BSkeletonTable,
  BCard,
  BButton,
  BTable,
  BSpinner,
  BBadge,
} from 'bootstrap-vue'
import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'
import TableAction from '@/layouts/components/custom/TableAction.vue'

export default {
  components: {
    BSkeletonTable,
    BCard,
    BButton,
    BTable,
    BSpinner,
    BBadge,
    Pagination,
    TableHeader,
    TableAction,
  },
  data() {
    return {
      tableFields: [
        { key: 'name', label: 'Nama' },
        { key: 'guard_name', label: 'Guard Name' },
        { key: 'permissions', label: 'Permisions', thStyle: { width: '45%' } },
        { key: 'actions', label: '', thStyle: { width: '1%' } },
      ],
      deletedData: '',
      isDeleting: false,
    }
  },
  computed: {
    ...mapState('roles', ['roles', 'isLoading']),
    query() {
      return this.$route.query
    },
    tableAction() {
      return [
        {
          access: null,
          to: 'roles-edit|id:id|start:1',
          action: '',
          icon: 'EditIcon',
          title: 'Edit',
        },
        {
          access: null,
          to: null,
          action: data => { this.deleteConfirmation(data.id) },
          icon: 'TrashIcon',
          title: 'Hapus',
        },
      ]
    },
  },
  async created() {
    await this.getRolesList(this.query)
  },
  methods: {
    ...mapActions('roles', ['getRolesList', 'deleteRole']),
    deleteConfirmation(value) {
      this.$bvModal.show('modal-delete')
      this.deletedData = value
    },
    async handleDelete() {
      this.isDeleting = true
      await this.deleteRole({ rolesId: this.deletedData })
      this.isDeleting = false
      this.$bvModal.hide('modal-delete')
    },
  },
}
</script>
